<template>
  <div class="modal">
    <header>
      <h2 v-if="title">{{title}}
      <svg v-if="simboltitle && (simboltitle === 'upper')" class="side "><use :xlink:href="'#side-front'"></use></svg>
      <svg v-if="simboltitle && (simboltitle === 'lower')" class="side "><use :xlink:href="'#side-back'"></use></svg>

      </h2>
     <h2
        v-if="$slots.header"><slot name="header"></slot></h2>
    </header>

    <section
      class="body relative"
      :class="{scroll: this.scroll}">
      <slot name="body">Default body</slot>
    </section>

    <footer class="relative">
      <slot name="footer">
        <btn icon="ok" success @click.native="closeDialog()"></btn>
      </slot>
    </footer>

    <DropOverlay v-if="!disableOverlay"/>
  </div>
</template>

<script>
  import DropOverlay from '@/components/basic/DropOverlay'
  import interact from 'interactjs'
  import Btn from '@/components/basic/Btn'

  export default {
    name: 'IzDialog',
    props: {
      title: String,
      scroll: Boolean,
      disableDrag: Boolean,
      disableEscape: Boolean,
      simboltitle: String,
      disableOverlay: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        draggableHandle: null
      }
    },
    mounted () {
      if (!this.disableDrag) {
        this.draggableHandle = interact(this.$el)
          .draggable({
            inertia: true,
            allowFrom: 'header',
            restrict: {
              restriction: 'parent',
              endOnly: true,
              elementRect: {top: 0, left: 0, bottom: 1, right: 1}
            },
            onmove: this.dragMoveListener
          })
      }
    },
    created () {
      document.addEventListener('keyup', this.handleEscape)
    },
    destroyed () {
      document.removeEventListener('keyup', this.handleEscape)
    },
    methods: {
      handleEscape () {
        if ((event.keyCode === 27) && (!this.disableEscape)) {
          this.closeDialog()
        }
        if (event.keyCode === 13) {
          this.$emit('enterkey')
        }
      },
      dragMoveListener (event) {
        const target = event.target
        // keep the dragged position in the data-x/data-y attributes
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        // translate the element
        // account for 50% initial translate
        target.style.webkitTransform =
          target.style.transform =
            'translate(' + (x - (target.clientWidth / 2)) + 'px, ' + (y - (target.clientHeight / 2)) + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      },
      closeDialog () {
        // keep this for compatibility
        this.$store.commit('closeDialogs')
      }
    },
    components: {
      Btn,
      DropOverlay
    },
    beforeDestroy () {
      if (this.draggableHandle) {
        this.draggableHandle.unset()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal {
    box-shadow: 0 0 3px $gray-medium;
    position: absolute;
    z-index: 1000;
    border-radius: 5px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    header {
      background: $gray-very-light;

      h2 {
        color: $gray-dark;
        text-align: center;
        font-size: 2rem;
        line-height: 2.5rem;
        padding: 0.5rem 0;
        font-family: SourceSansSemiBold;
        margin: 0;
      }
    }
  }

  section.body {
    padding: $size-grid / 4;
    background: $white;
    max-height: calc(100vh - 8rem);
    /*overflow: hidden;*/

    &.scroll {
      overflow-y: scroll;

      // hide scrollbar when not visible
      &::-webkit-scrollbar:disabled {
        width: 1px;
        background: transparent;
      }
    }

    // next div is slot parent
    > div {

      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  footer {
    padding: 0 $size-grid / 4 $size-grid / 4 $size-grid / 4;
    background: $white;
    display: flex;
    justify-content: center;

    .button:not(.extra-button) {
      padding: 0 $size-grid / 2.5;
    }

    .button + .button {
      margin-left: -2px;
    }

    .to-left {
      position: absolute;
      left: $size-grid / 4;
    }
  }
  .side {
    transform: translateY(0.7rem);
    height: $size-grid / 2;
    width: $size-grid / 2;
   }
</style>



// WEBPACK FOOTER //
// src/components/basic/Dialog.vue